export default function authHeader() {
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return {
    'Content-Type': 'application/json',
    Authorization: `${accessType} ${accessToken}`,
  };
}




// WEBPACK FOOTER //
// ./src/helper/authHeader.js